import {LitElement, html, css} from 'lit';
import {customElement, property} from 'lit/decorators.js';

/**
 * iOS-style Toggle Switch Component
 * Accessible toggle switch with smooth animations
 */
@customElement('toggle-switch')
export class ToggleSwitch extends LitElement {
  @property({type: Boolean})
  checked = false;

  @property({type: String})
  ariaLabel = 'Toggle';

  static styles = css`
    :host {
      display: inline-block;
      width: 48px;
      height: 24px;
    }

    .toggle-container {
      position: relative;
      display: block;
      width: 48px;
      height: 24px;
      cursor: pointer;
    }

    .toggle-track {
      position: absolute;
      width: 100%;
      height: 100%;
      background-color: #1A1A1A;
      border-radius: 12px;
      transition: background-color 0.3s ease;
    }

    .toggle-track.checked {
      background-color: #557BD5;
    }

    .toggle-thumb {
      position: absolute;
      top: 2px;
      left: 2px;
      width: 20px;
      height: 20px;
      background-color: #0D0D0D;
      border-radius: 10px;
      transition: transform 0.3s ease;
    }

    .toggle-thumb.checked {
      transform: translateX(24px);
    }

    input {
      position: absolute;
      opacity: 0;
      width: 0;
      height: 0;
    }
  `;

  private _handleChange(e: Event) {
    this.checked = (e.target as HTMLInputElement).checked;
    this.dispatchEvent(new CustomEvent('toggle-change', {
      detail: {checked: this.checked},
      bubbles: true,
      composed: true
    }));
  }

  render() {
    return html`
      <label class="toggle-container">
        <input
          type="checkbox"
          .checked="${this.checked}"
          @change="${this._handleChange}"
          aria-label="${this.ariaLabel}"
        />
        <div class="toggle-track ${this.checked ? 'checked' : ''}"></div>
        <div class="toggle-thumb ${this.checked ? 'checked' : ''}"></div>
      </label>
    `;
  }
}

declare global {
  interface HTMLElementTagNameMap {
    'toggle-switch': ToggleSwitch;
  }
}
